import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["error", "name", "className", "title", "titleCenter", "caption", "required", "value"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef, useEffect, useRef } from "react";
import classnames from "classnames";
import HiddenField from "./HiddenField";
import styles from "@/styles/Form.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReadOnlyField = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      error,
      name,
      className,
      title,
      titleCenter,
      caption,
      required,
      value
    } = props,
    _props = _objectWithoutProperties(props, _excluded);
  const input = useRef();
  useEffect(() => {
    if (input.current) {
      input.current.value = value;
    }
  }, [value]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, {
        [styles.center]: titleCenter,
        [styles.required]: required
      }),
      children: title
    }), /*#__PURE__*/_jsx("input", _objectSpread({
      ref: input,
      type: "text",
      name: name,
      className: classnames(styles.textInput, className),
      defaultValue: "",
      tabIndex: "-1",
      disabled: true,
      readOnly: true
    }, _props)), /*#__PURE__*/_jsx(HiddenField, {
      ref: ref,
      name: name,
      value: value
    }), caption && /*#__PURE__*/_jsx("p", {
      className: styles.caption,
      children: caption
    }), error && /*#__PURE__*/_jsx("span", {
      className: styles.errorMessage,
      children: error
    })]
  });
});
ReadOnlyField.displayName = "ReadOnlyField";
export default ReadOnlyField;